export default __webpack_public_path__ + "static/media/oi_4.db61d4de.mp3";